import React from 'react';
import ReactDOM from 'react-dom';
import jQuery from 'jquery';
import Login from 'comp/login';

const install = (editorInstance) => {

  const loginModalContainer = jQuery('<div id="login-modal"></div>');
  jQuery(editorInstance.e).append(loginModalContainer);
  const domIndex = 0;

  ReactDOM.render(
    <Login />,
    loginModalContainer[domIndex]
  );
};

export default {install};



// WEBPACK FOOTER //
// ./src/ui/login/installer.jsx